<template>
	<div class="friend">
		<div class="friendList">
			<ul v-if="friendList.length>0">
				<li v-for='(item, index) in friendList'>
					<img v-bind:src="item.avatar" class="avatar" @click="friendreport(item.id)">
					<div class="text">
						<p class="nickName">{{ item.nickname }}</p>
						<p class="desc">完成了本测评，ta的代表动物竟然是：</p>
					</div>
					<div class="animal">
						<img v-bind:src="item.images" @click="friendreport(item.id)">
					</div>
				</li>
				<p class="busy" v-if="busy">正在加载好友报告</p>
			</ul>
			<!-- 没好友 -->
			<div v-else class="empty">
				<div class="smile"></div>
				<p>分享本报告，此处有惊喜，记得常回来看看！</p>
			</div>
			<div class="qrcode">
				<img src="../../static/images/funreport-qrcode.png" alt="qrcode">
			</div>

			<!-- 没好友 -->
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import router from '../router.js'

export default {
	name: 'friendList',
	computed: mapState({
		friendList: state => state.friendList,
		busy: state => state.busy
	}),
	methods:{
		friendreport(id) {
			router.push({
				path: '/sharereport/',
				name: 'sharereport',
				params: { reportId: id }
			});
		}
	}
}
</script>

<style scoped lang="scss">
$font-size-base:32; // Base on 320rem * 0.5;
@function topx($rem) {
  @return $rem/$font-size-base;
}
.friend {
	.friendList {
		margin: 0 topx(30rem * 0.5) 0 topx(30rem * 0.5);
		ul {
			position: relative;
			padding-bottom: topx(30rem);
			.busy {
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				text-align: center;
				font-size: topx(22rem * 0.5);
				line-height: topx(22rem * 0.5);
				color: #252323;
			}
			li {
				position: relative;
				overflow: hidden;
				height: topx(110rem * 0.5);
				margin-bottom: topx(15rem * 0.5);
				border-radius: topx(55rem * 0.5);
				background: #f6f6f6;
				.avatar {
					float: left;
					width: topx(78rem * 0.5);
					height: topx(78rem * 0.5);
					margin: topx(15rem * 0.5);
					border: topx(1rem * 0.5) solid #d4d4d4;
					border-radius: 50%;
				}
				.text {
					margin: topx(12rem * 0.5) 0 0 0;
					p {
						margin: 0;
					}
					.nickName {
						font-size: topx(22rem * 0.5);
						line-height: topx(39rem * 0.5);
						color: #7a7a7a;
					}
					.desc {
						margin: 0;
						font-size: topx(22rem * 0.5);
						line-height: topx(39rem * 0.5);
						color: #252323;
					}
				}
				.animal {
					position: absolute;
					top: 0;
					right: 0;
					width: topx(78rem * 0.5);
					height: topx(78rem * 0.5);
					margin: topx(15rem * 0.5);
					border: topx(1rem * 0.5) solid #d4d4d4;
					border-radius: 50%;
					overflow: hidden;
					img {
						position: absolute;
						top: 50%;
						transform: translate(0,-50%);
						width: topx(78rem * 0.5);
					}
				}
			}
		}
	}
	.empty {
		.smile {
			margin: 0 auto topx(30rem * 0.5) auto;
			width: topx(116rem * 0.5);
			height: topx(120rem * 0.5);
			background: url('../../static/images/funreport-wink.png') no-repeat;
			background-size: topx(116rem * 0.5);
		}
		p {
			text-align: center;
			font-size: topx(22rem * 0.5);
			color: #252323;
		}
	}
	.qrcode {
		margin: topx(10rem * 0.5) auto topx(30rem * 0.5) auto;
		width: topx(123rem * 0.5);
		height: topx(123rem * 0.5);
		img {
			width: 100%;
		}
	}
}
</style>



// WEBPACK FOOTER //
// funFriendList.vue?9c2539a8